module.exports = __webpack_public_path__ + "static/board-9f18e7171c0af64cc5c1191c27cb49e0.jpg";